/**
 * ShoppingScreen.jsx
 * Shopping list screen
 */
import React from 'react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ShoppingScreen = () => {
  const { t } = useTranslation();
  return (
  <div className="p-4 space-y-4">
    <div className="flex justify-between items-center pt-2">
      <h1 className="text-white text-xl font-bold">{t('nutrition.shopping_list', 'Einkaufsliste')}</h1>
      <button className="w-10 h-10 bg-yellow-500 rounded-xl flex items-center justify-center">
        <Plus className="w-5 h-5 text-black" />
      </button>
    </div>

    {/* Categories */}
    <div className="space-y-4">
      {[
        { name: 'Obst & Gemüse', icon: '🥬', items: ['Bananen', 'Spinat', 'Tomaten'] },
        { name: 'Milchprodukte', icon: '🥛', items: ['Griechischer Joghurt', 'Eier', 'Käse'] },
        { name: 'Vorratskammer', icon: '📦', items: ['Haferflocken', 'Quinoa', 'Olivenöl'] },
      ].map(category => (
        <div key={category.name} className="bg-zinc-800/50 rounded-xl p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-xl">{category.icon}</span>
            <span className="text-white font-medium">{category.name}</span>
            <span className="text-zinc-500 text-sm">({category.items.length})</span>
          </div>
          {category.items.map(item => (
            <div key={item} className="flex items-center gap-3 py-2 border-b border-zinc-700/50 last:border-0">
              <div className="w-5 h-5 border-2 border-zinc-600 rounded" />
              <span className="text-zinc-300 text-sm flex-1">{item}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
  );
};

export default ShoppingScreen;
